import React, { Component } from 'react';
import AccessContainer from '../../access/AccessContainer';
import { RootState } from '../../../redux/store';
import { changeBasic } from '../../../redux/actions/BasicActions';
import { ConnectedProps } from 'react-redux/es/exports';
import { connect } from 'react-redux';
import { AccessBase } from '../../../domain/access/BaseAccess';
import RoleHelper from '../../../RoleHelper';

class BasicAccessComponent extends Component<Props> {
  render() {
    const {
      basic: { basicVariable },
    } = this.props;
    const access: AccessBase = { permission: basicVariable.permission, collaborators: basicVariable.collaborators };
    return <AccessContainer access={access} changeAccess={this.changeBasicVariableAccess} disabled={!RoleHelper.canManage('EnrichmentBasic')} />;
  }

  private changeBasicVariableAccess = (access: AccessBase) => {
    const {
      basic: { basicVariable },
      changeBasic,
    } = this.props;
    basicVariable.permission = access.permission;
    basicVariable.collaborators = access.collaborators;
    changeBasic(basicVariable);
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  basic: state.basic,
});
const mapDispatchToProps = { changeBasic };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(BasicAccessComponent);
